module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Untersiggenthal_AG-1e13839c7ee2916d4ee39ba30f4e5c79.svg";